export default __webpack_public_path__ + "static/media/pdf.ae7926f4.svg";